import { Phase } from "../../configLookup/components/Props"
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Divider } from "@mui/material";
import JsonView from 'react18-json-view'
import styles from "../configInfo.module.css";
import 'react18-json-view/src/style.css'

interface Props {
    phase: Phase;
}

const PhaseInfo:React.FC<Props> = ( { phase } ) => {

    const findVC = (VC : any)  => {

        let strArr:String[] = [];
        let spaceCount = 0;

        if(VC.Clause !== undefined && VC.Clause !== null) {     // if just one, then no array to loop through
            let retStr = VC.Clause.Left.Label + ' ' + VC.Clause.Operator + ' ' + VC.Clause.Right
            strArr.push(retStr)
            return strArr
        }

        if(VC.Children !== undefined && VC.Children !== null) { // we need to iterate through and create VC
            // it's possible for a child to also have children, so as we iterate we need to check

            VC.Children.forEach((child: any, idx: number) => {
                spaceCount += 4;
                if(child.Clause !== null) {
                    let str = findVC(child)
                    strArr = strArr.concat(str)
                    if(VC.Children.length !== idx + 1) {strArr.push(VC.Conjunction.toUpperCase())}
                }
                else if(child.Children !== undefined && child.Children !== null) {
                    // we need to go through and findVC for each child
                    
                    for(let i=0; i<child.Children.length; i++) {
                        let tempStr = findVC(child.Children[i])
                        strArr = strArr.concat(tempStr)
                       if(child.Children.length !== i+1) {strArr.push(child.Conjunction.toUpperCase())}
                    }
                }
            })
            for(let k=0; k<strArr.length; k++) {
                strArr[k] = ' '.repeat(spaceCount) + strArr[k]
            }

        }

        return strArr
    }

    let VCArr:String[] = [];
    if(phase.visibilityCriteria !== undefined && phase.visibilityCriteria !== null) {
        VCArr = findVC(phase.visibilityCriteria)
    }

  return (
    <div className={styles.phaseInfoContainer}>

        <Card>
            <CardContent>
                <Typography><b>{phase.name}</b></Typography>
                <Typography><b>Phase Type: </b>{phase.phaseType}</Typography>
                <Divider />
                <br/>
                <Accordion className={styles.VCAcc}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}>
                        <b>Visibility Criteria</b>
                    </AccordionSummary>
                    <AccordionDetails>
                        {VCArr.map(vc => <p>{vc}</p>)}
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}>
                        <b>Phase Status Events</b>
                    </AccordionSummary>
                    <AccordionDetails>
                        {phase.phaseStatusEvents.map((event, idx) => (
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}><b>Event {idx}</b></AccordionSummary>
                                <AccordionDetails sx={{margin:.1}}>
                                    <Divider/>
                                    <p>Event Type: {event.leadStatusEventType}</p>
                                    <p>Lead Status Text: {event.leadStatusText}</p>
                                    <p>Lead Type: {event.leadType}</p>
                                    <p>Status Type: {event.statusType}</p>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}>
                            <b>Phase Details</b>
                    </AccordionSummary>
                    <AccordionDetails>
                        <JsonView src={phase.phaseDetails} enableClipboard={true} collapseObjectsAfterLength={5} />
                    </AccordionDetails>
                </Accordion>
            </CardContent>
        </Card>
    </div>
  )
}

export default PhaseInfo